<div class="container-fluid">
    <div class="card card-outline-primary">
        <!--<div class="card-header card-primary text-sm-center text-white text-center">
            User Privillage
        </div>-->
        <div class="panel-body">
            <div class="card-block">
                <!--********************************************-->
                <div class="row">
                    <!--<div class="col-md-4">
                        <button class="btn-sm" (click)="ngOnInit()"><i class="fa fa-home"></i></button>
                        <button class="btn btn-sm"
                                *ngFor="let service of levelBreadcrumbArray"
                                (click)="changeLevel(service)">
                            <i class="fa fa-angle-double-right"></i>
                            {{translate.currentLang == 'ar'? service.nameAr: service.nameEn}}
                        </button>
                    </div>-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="">SecLogins</label>
                            <select #activeSelect (change)="SecLoginsId(activeSelect.value)" class="form-control form-control-sm">
                                <option></option>
                                <option class="form-control form-control-sm" [value]="secloginDes.id | json" *ngFor="let secloginDes of seclogins">{{ secloginDes.descriptionEn }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <sanabel-selectize  appcode="1015" #parentServiceSelectize 
                                               (clicked)="onServicesSelectedLevTwo($event)">
                            </sanabel-selectize>
                        </div>
                    </div>
                </div>

                <!--*********************** services area ***********************************************-->
                <table class="table">
                    <thead class="bg-faded">
                        <tr>
                            <td colspan="6">
                                <input type="text" class="form-control form-control-sm" name="serviceSettingSearchKey"
                                       placeholder="search for service"
                                       (keyup)="getServices()"
                                       [(ngModel)]="serviceSettingSearchKey" />
                            </td>
                        </tr>
                        <tr class="row text-md-center">
                            <td class="col-md-4 text-md-left ml-1">{{ 'Service' | translate }} {{ 'Name' | translate }}</td>


                            <td class="col-md-1 fa fa-edit"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row text-md-center"
                            *ngFor="let Services of lastServicesArrayLevTwo;let i = index">
                            <td class="col-md-4 text-md-left ml-1 pb-0">
                                <label>{{translate.currentLang=='ar'? Services.nameAr : Services.nameEn}}</label>
                            </td>


                            <td class="col-md-1 pb-0">
                                <input class="form-control form-control-sm" type="checkbox" [(ngModel)]="Services.selected" />
                            </td>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <div class="container-fluid">
                              <div class="row">
                                <div class="col">
                                  <div class="list-group-item">
                                    <btns-ctrl [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
                                  </div>
                                  </div>
                                </div>
                              </div>
                          </td>
                        </tr>
                    </tbody>
                 
                </table>

            </div>
            <hr />
        </div>
    </div>

    <div class="card panel-default">
        <div class="card-header"><h6>service of level 4</h6></div>
        <div class="panel-body">
            <div class="container">
                <!--********************************************-->
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <button class="btn-sm" (click)="ngOnInit()"><i class="fa fa-home"></i></button>
                            <button class="btn btn-sm"
                                    *ngFor="let service of levelBreadcrumbArray"
                                    (click)="changeLevel(service)">
                                <i class="fa fa-angle-double-right"></i>
                                {{translate.currentLang == 'ar'? service.nameAr: service.nameEn}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="">SecLogins</label>
                            <select #activeSelect (change)="SecLoginsId(activeSelect.value)" class="form-control form-control-sm">
                                <option></option>
                                <option class="form-control form-control-sm" [value]="seclogin.id | json" *ngFor="let seclogin of secloginLevTwo">{{ seclogin.descriptionEn }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <sanabel-selectize appcode="1038" #parentServiceSelectize 
                                               (clicked)="onServicesSelected($event)">
                            </sanabel-selectize>
                        </div>
                    </div>
                </div>
                <!--*********************** services area ***********************************************-->
                <table class="table">
                    <thead class="bg-faded">
                        <tr>
                            <td colspan="6">
                                <input type="text" class="form-control form-control-sm" name="serviceSettingSearchKey"
                                       placeholder="search for service"
                                       (keyup)="getServices()"
                                       [(ngModel)]="serviceSettingSearchKey" />
                            </td>
                        </tr>
                        <tr class="row text-md-center">
                            <td class="col-md-4 text-md-left ml-1">{{ 'Service' | translate }} {{ 'Name' | translate }}</td>


                            <td class="col-md-1 fa fa-edit"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row text-md-center"
                            *ngFor="let Services of lastServicesArray;let i = index">
                            <td class="col-md-4 text-md-left ml-1 pb-0">
                                <label>{{translate.currentLang=='ar'? Services.nameAr : Services.nameEn}}</label>
                            </td>


                            <td class="col-md-1 pb-0">
                                <input class="form-control form-control-sm" type="checkbox" [(ngModel)]="Services.selected" />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6">

                                <div class="btn-group " role="group" aria-label="Basic example">
                                    <button type="button" class="btn btn-primary" (click)="saveLevThree($event)">Save</button>
                                    <button type="button" class="btn btn-secondary" (click)="cancel()">Back</button>

                                </div>
                            </td>
                        </tr>
                    </tbody>
               
                </table>

            </div>
            <hr />

        </div>
    </div>
</div>



